import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { ProductoService } from '../_services/producto.service';
import { MessageService } from '../_services/message.service';
import { UserService } from '../_services/user.service';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html'
})
export class AutoLoginComponent implements OnInit {

  idToken = '';
  portalUrl = '';
  mostrarError = false;

  constructor(private authenticationService: AuthenticationService,
              private userService: UserService,
              private activatedRoute: ActivatedRoute,
              private productoService: ProductoService,
              private messageService: MessageService) {

  }

  ngOnInit(): void {
    let urlParams: any;
    this.activatedRoute.queryParams.subscribe(params => {
      urlParams = {
        idAplicacion: this.activatedRoute.snapshot.paramMap.get('idAplicacion'),
        redirectUrl: params.redirectUrl == undefined ? '' : params.redirectUrl,
        filtroAdicional: params.filtroAdicional == undefined ? '' : params.filtroAdicional
      };
      let datosUsuario = atob(this.activatedRoute.snapshot.paramMap.get('usuario'));
      let username = datosUsuario.split(":")[0];
      let password = datosUsuario.split(":")[1];
      this.productoService.setCurrentApp(urlParams.idAplicacion);
      this.productoService.setLoginParams(urlParams.idAplicacion, urlParams.filtroAdicional, urlParams.redirectUrl);
      this.authenticationService.login(username, password, urlParams.idAplicacion, urlParams.filtroAdicional)
      .subscribe(data => {
        this.authenticationService.redirectUsuarioLogeado(data, urlParams.redirectUrl);
      },
        error => {
          switch (error.status) {
          }
        });
    });
  }
}
